import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import CollectionIndex from "./components/CollectionIndex";
import EvidenceChain from "./components/EvidenceChain";
import Timeline from "./components/Timeline";
import HeatRank from "./components/HeatRank";
import Disclaimer from "./components/Disclaimer";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="hammer" className="min-h-screen w-full bg-background-50 text-foreground-900">
      <TopNav />
      <main>
        <Hero />
        <CollectionIndex />
        <EvidenceChain />
        <Timeline />
        <HeatRank />
        <Disclaimer />
      </main>
      <Footer />
    </div>
  );
}